<template>
  <div class="privacy-wrap">
    <div class="header">
      <span class="back" @click="$router.back()">&lt; 返回</span>
      <h2>乘风快购隐私政策</h2>
    </div>
    <div class="content">
      <p class="time">生效日期：2026年07月10日</p>
      <p>本政策旨在向您说明乘风快购如何收集、使用、存储、共享、保护您的个人信息，保障您的隐私权益。使用平台外卖服务前，请完整阅读本隐私政策。您使用平台即代表同意我们按照本政策处理您的个人信息。</p>
      <p>如您是未成年人，请在监护人陪同下阅读；监护人同意后方可使用平台。</p>

      <h3>一、我们收集哪些个人信息</h3>
      <h4>1. 注册、登录必备信息</h4>
      <p>手机号：用于账号注册、登录、短信验证、找回密码、订单通知，为平台基础必要信息，不提供将无法注册使用。</p>

      <h4>2. 下单配送所需信息</h4>
      <ul>
        <li>收货姓名、联系电话、收货详细地址：用于骑手准确配送商品；</li>
        <li>订单商品、消费记录、支付凭证：用于生成订单、售后对账、开票；</li>
        <li>实时定位信息：获取附近商家、预估配送时长、骑手导航，您可随时在系统关闭定位权限。</li>
      </ul>

      <h4>3. 主动提供的信息</h4>
      <p>联系客服、售后维权时您上传的照片、聊天记录；评价商家/骑手填写的文字、图片；开具发票提供的企业名称、税号。</p>

      <h4>4. 设备与日志信息</h4>
      <p>设备型号、系统版本、网络类型、页面点击记录、崩溃日志，用于优化平台功能、排查故障、风控防刷单。</p>

      <h3>二、信息使用用途</h3>
      <p>1. 完成外卖交易：匹配商家、分配骑手、完成配送、结算货款；</p>
      <p>2. 订单通知：短信、站内信推送订单状态、配送提醒、售后进度；</p>
      <p>3. 权益服务：发放优惠券、会员活动、生日福利、个性化推荐店铺；</p>
      <p>4. 安全风控：识别盗号、恶意退款、刷单、诈骗行为，保障资金与账号安全；</p>
      <p>5. 客服售后：核对订单、处理投诉、理赔、退款；</p>
      <p>6. 合规举证：配合公安、市场监管等官方部门依法调取信息。</p>

      <h3>三、信息存储与保护</h3>
      <p>3.1 数据存储：您的个人信息存储于国内合规服务器，仅在法律法规要求期限内保存：订单数据保存3年，账号基础信息保存至账号注销后1年，日志记录保存180天。</p>
      <p>3.2 安全防护：采用加密传输、权限隔离、防火墙、数据脱敏等技术保护手机号、地址、支付信息；内部员工严格分级权限，禁止私自导出用户数据。</p>
      <p>3.3 支付信息：银行卡、支付密码等支付敏感信息由第三方支付机构独立保管，平台不保存完整支付密钥。</p>

      <h3>四、信息共享范围</h3>
      <p>我们仅在以下场景合法共享您的信息，不会出售、倒卖用户个人信息：</p>
      <ul>
        <li>配送骑手：仅展示收货姓名、电话、地址，用于上门送餐；订单完成后骑手无法长期查看完整信息；</li>
        <li>入驻商家：查看您下单商品、联系方式，用于出餐、核对订单；</li>
        <li>第三方支付机构：完成支付、退款结算；</li>
        <li>政府执法部门：收到法定文书后依法配合调取；</li>
        <li>合规服务商：短信推送、地图定位、客服系统，服务商签订保密协议。</li>
      </ul>

      <h3>五、您拥有的隐私权利</h3>
      <p>1. 访问权：个人中心可查看全部订单、收货地址、个人基础信息；</p>
      <p>2. 修改权：随时修改收货地址、昵称、联系方式；</p>
      <p>3. 删除权：可删除历史地址、评价图片；账号注销后我们将清除非法定留存信息；</p>
      <p>4. 撤回授权：手机系统关闭定位、相册、通讯录权限，关闭后对应功能无法使用；</p>
      <p>5. 注销账号：个人中心提交注销申请，7天冷静期后永久清空个人数据。</p>

      <h3>六、Cookie与本地缓存</h3>
      <p>平台使用本地缓存记录登录状态、浏览店铺记录，用于提升打开速度；您可清除浏览器缓存清空相关数据，清除后需重新登录。</p>

      <h3>七、未成年人信息保护</h3>
      <p>若您为未满18周岁未成年人，请监护人代为阅读本政策，未成年人不建议单独大额消费；如发现未成年人信息被违规收集，监护人可联系客服删除。</p>

      <h3>八、政策更新</h3>
      <p>平台更新隐私政策将在网站首页公告，重大变更弹窗提示用户；持续使用平台视为同意更新后的条款。</p>

      <h3>九、联系方式</h3>
      <p>若您对个人信息处理、隐私保护有疑问、投诉，可联系客服热线19867383325，或平台在线客服处理隐私相关诉求。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  data() {
    return {};
  },
  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<style scoped>
.privacy-wrap {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
}
.header {
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 14px 16px;
  box-shadow: 0 1px 4px #eee;
  z-index: 99;
}
.back {
  color: #007aff;
  font-size: 16px;
  margin-right: 20px;
  cursor: pointer;
}
h2 {
  font-size: 18px;
  margin: 0;
  color: #333;
}
.content {
  padding: 16px;
  background: #fff;
  margin: 12px;
  border-radius: 8px;
  line-height: 1.75;
  font-size: 14px;
  color: #444;
}
.time {
  color: #999;
  font-size: 13px;
  margin-bottom: 10px;
}
h3 {
  font-size: 16px;
  color: #222;
  margin: 22px 0 8px;
}
h4 {
  font-size: 15px;
  margin: 14px 0 6px;
  color: #333;
}
ul {
  padding-left: 20px;
  margin: 8px 0;
}
li {
  margin: 6px 0;
}
</style>
